import {commonConstants} from "../constants";

const initialState = {
    isSidebarVisible: true,
    isUsermenuVisible: true,
    redirectTo: null,
    currentUser: null,
    token: null,
    appLoaded: false,
    isProgressing: false
};

export function common(state = initialState, action) {
    switch (action.type) {

        case commonConstants.FILTER:
            return {
                ...state,
                filter: action.data,
            };
        case commonConstants.FORM_REQUEST:
            return {
                ...state,
                isProgressing: true,
            };
        case commonConstants.FORM_SUCCESS:
            return {
                ...state,
                isProgressing: false,
            };

        case commonConstants.FORM_FAILURE:
            return {
                ...state,
                isProgressing: false,
            };

        case commonConstants.USERMENU_VISIBILITY_SET:
            return {
                ...state,
                isUsermenuVisible: action.isUsermenuVisible
            }
        case commonConstants.UPDATE_FIELD_AUTH:
            return {
                ...state,
                [action.key]: action.value
            };
        case commonConstants.LOGOUT:
            return {
                ...state,
                redirectTo: '/login',
                isLogin: false,
                token: null,
                currentUser: null,
            };
        case commonConstants.PAGE_REDIERCT:
            return {
                ...state,
                redirectTo: action.redirectTo
            }
        case commonConstants.REDIRECTED:
            return {
                ...state,
                redirectTo: null
            };
        case  commonConstants.APP_LOAD:
            return {
                ...state,
                appLoaded: true,
                currentUser: action.user,
                token: action.token
            };
        case commonConstants.LOGIN:
            return {
                ...state,
                token: action.token || null,
                currentUser: action.user
            };
        case commonConstants.COMMON_IMAGE_UTL:
            return {
                ...state,
                imageUrl: action.imageUrl
            };
        default:
            return state;
    }
};
